export const EnvGet = () => {
  var serviceHost = process.env.REACT_APP_PROD_API_SERVICE_URL; //default to prod in case all else fails
  var hostName = window.location.hostname;

  // decisions from where to make the request
  if (new RegExp('.gc.pub').test(hostName)) {
    //GC Servers
    if (new RegExp('.dev.').test(hostName)) {
      serviceHost = process.env.REACT_APP_GCDEV_API_SERVICE_URL;
    } else {
      serviceHost = process.env.REACT_APP_QADEV_API_SERVICE_URL;
    }
  }
  if (new RegExp('bankofamerica').test(hostName)) {
    //MCOE Servers
    if (new RegExp('-dev').test(hostName)) {
      serviceHost = process.env.REACT_APP_MCOEDEV_API_SERVICE_URL;
    } else if (new RegExp('-stg').test(hostName)) {
      serviceHost = process.env.REACT_APP_MCOESTG_API_SERVICE_URL;
    } else {
      serviceHost = process.env.REACT_APP_PROD_API_SERVICE_URL;
    }
  }

  return serviceHost;
};
